import { useGetMany, type Identifier } from "ra-core";
import { useMemo } from "react";

import type { Company } from "../types";

/** Names of the companies referenced by `records`, loaded in one request */
export const useCompanyNames = (
  records: { company_id?: Identifier | null }[],
): Map<Identifier, string> => {
  const ids = useMemo(
    () => [
      ...new Set(
        records
          .map((record) => record.company_id)
          .filter((id): id is Identifier => id != null),
      ),
    ],
    [records],
  );
  const { data } = useGetMany<Company>(
    "companies",
    { ids },
    { enabled: ids.length > 0 },
  );
  return useMemo(
    () => new Map((data ?? []).map((company) => [company.id, company.name])),
    [data],
  );
};
